import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { map } from 'rxjs';
import Order from 'src/app/models/Order';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { numberToCurrency, STATUS_CHANGE } from 'src/app/services/order.service';

@Component({
	selector: 'app-manager-order-item-draw',
	templateUrl: './manager-order-item-draw.component.html',
	styleUrls: ['./manager-order-item-draw.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManagerOrderItemDrawComponent implements OnInit {
	orderValue: Order;
	numberToCurrency = numberToCurrency;
	discount$ = this.appSettingsService.appSettings$.pipe(map(s => s.isShowDiscountOn));

	@Input() set order(value: Order) {
		console.log('ORDER', value);
		this.orderValue = value;
	}
	@Output() sendOrderStatusChange = new EventEmitter<{
		order: Order;
		status: STATUS_CHANGE;
	}>();

	constructor(private appSettingsService: AppSettingsService) {}

	ngOnInit() {}
	updateStatus(data: { order: Order; status: STATUS_CHANGE }) {
		this.sendOrderStatusChange.emit(data);
	}

	getDiscountSum() {
		if (
			!this.orderValue ||
			!this.orderValue.totalPrice ||
			!this.orderValue.originTotalPrice ||
			+this.orderValue.originTotalPrice === 0
		) {
			return 0;
		}
		if (+this.orderValue?.totalPrice <= +this.orderValue.originTotalPrice) {
			return (+this.orderValue.totalPrice - +this.orderValue.originTotalPrice).toFixed(2);
		}

		return 0;
	}
}
